import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CreateAppointmentHolidayForm } from './forms/CreateAppointmentHolidayForm';
import { AppointmentHolidaysTable } from './table/appointmentHolidays/AppointmentHolidaysTable';
import { PageSurface } from '../../layout/Workspace';

function HolidaysSettings(props) {

  const [refreshTable, setRefreshTable] = useState(false);
  
  return (
    <div className="appointment-settings-grid">
      <PageSurface
        className="appointment-settings-create-surface"
        header={(
          <h2 className="appointment-settings-panel-title">
            <FormattedMessage id="components.pages.appointments.holidays_settings.add_holiday.title"/>
          </h2>
        )}
      >
        <div className="appointment-settings-create-form">
          <CreateAppointmentHolidayForm 
            actionRefreshTable = {() => setRefreshTable(!refreshTable)}
          />
        </div>
      </PageSurface>
      <PageSurface
        className="appointment-settings-list-surface"
        header={(
          <h2 className="appointment-settings-panel-title">
            <FormattedMessage id="components.pages.appointments.holidays_settings.list_holidays.title"/>
          </h2>
        )}
      >
        <div className="appointment-settings-list">
          <AppointmentHolidaysTable 
            refreshTable = {refreshTable}
          />
        </div>
      </PageSurface>
    </div>
  );
}

export { HolidaysSettings };
